import { jwtDecode } from "jwt-decode";

const getUserRoles = (token) => {
  if (!token) return [];

  try {
    const decoded = jwtDecode(token);
    return decoded.roles || [];
  } catch (err) {
    console.error("Tokenni decode qilishda xatolik:", err);
    return [];
  }
};

export default getUserRoles;
